import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AccountActiveInactive,
  createAccount,
  deleteAccount,
  getAccountByID,
  getAllAccountIncremental,
  getAllAccounts,
  getAllActiveAccounts,
  getAllActiveAccountsUnderGroup,
  getAllDistributorAndRetailers,
  getAllPaymentAndReceipt,
  getAllSPDCIncremental,
  updateAccount,
  updateAccountDetails,
} from "./services/account.services";
import { IAccountInitialState, IAccountUnderGroup } from "./accountModel";

const initialState: IAccountInitialState = {
  formLoading: false,
  loading: false,
  error: "",
  AccountList: [],
  AccountUnderGroupList: [],
  AccountPaymentAndReceiptList: [],
  AccountSalesPurchaseDebitCreditList: [],
  AccountGuID: "",
  AccountID: null,
  AccountDetail: {
    user_type_id: 1,
    under_group_id: null,
    user_name: "",
    password: "",
    account_name: "",
    short_alias_name: "",
    contact_person_name: "",
    email: "",
    mobile_number: "",
    order_day: "",
    delivery_day: "",
    address1: "",
    pincode: null,
    country_id: null,
    state_id: null,
    city_id: null,
    district_id: null,
    is_permanent_address: false,
    address2: "",
    pincode2: null,
    country_id2: null,
    state_id2: null,
    city_id2: null,
    district_id2: null,
    payment_due_days: null,
    provide_bank_details: false,
    account_no: "",
    ifsc_code: "",
    bank_name: "",
    enable_credit_limit: false,
    limit_set_based_on_no_of_invoice: null,
    openingbalance_credit_debit: "credit",
    limit_set_based_on_outstanding_amount: null,
    opening_balance: "0",
    isapplycess: false,
    cess_per: null,
    pan_no: "",
    gst_no: "",
    gst_cancellation_date: "",
    gst_applicable_date: "",
    route_id: null,
    alternet_mobile_no: "",
    tax_type: "",
    tax_percentage: null,
    type_of_supply: "",
    gst_applicable: false,
    isactive: 1,
  },
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    clearAccountDetails: (state) => {
      state.AccountDetail = initialState.AccountDetail;
    },
    setAccountGuID: (state, action) => {
      state.AccountGuID = action.payload;
    },
    clearAccountGuID: (state) => {
      state.AccountGuID = initialState.AccountGuID;
    },
    setAccountID: (state, action) => {
      state.AccountID = action.payload;
    },
    clearAccountID: (state) => {
      state.AccountID = initialState.AccountID;
    },
    clearAccountList: (state) => {
      state.AccountList = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAccounts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAccounts.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.AccountList = action.payload || [];
      }
    );
    builder.addCase(getAllAccounts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AccountList = [];
    });
    builder.addCase(createAccount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createAccount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateAccount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAccount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteAccount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAccount.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAccountByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAccountByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.AccountDetail = action.payload;
    });
    builder.addCase(getAccountByID.rejected, (state, action) => {
      state.loading = false;
      state.AccountDetail = initialState.AccountDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveAccounts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAccounts.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.AccountList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveAccounts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AccountList = [];
    });

    builder.addCase(getAllActiveAccountsUnderGroup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAccountsUnderGroup.fulfilled,
      (state, action: PayloadAction<IAccountUnderGroup[]>) => {
        state.loading = false;
        state.AccountUnderGroupList = action.payload || [];
      }
    );
    builder.addCase(
      getAllActiveAccountsUnderGroup.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.AccountUnderGroupList = [];
      }
    );
    builder.addCase(AccountActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(AccountActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(AccountActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllAccountIncremental.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAccountIncremental.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.AccountList = action.payload || [];
      }
    );
    builder.addCase(getAllAccountIncremental.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AccountList = [];
    });
    builder.addCase(updateAccountDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAccountDetails.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateAccountDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllSPDCIncremental.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSPDCIncremental.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.AccountSalesPurchaseDebitCreditList = action.payload || [];
      }
    );
    builder.addCase(getAllSPDCIncremental.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AccountSalesPurchaseDebitCreditList = [];
    });

    builder.addCase(getAllPaymentAndReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPaymentAndReceipt.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.AccountPaymentAndReceiptList = action.payload || [];
      }
    );
    builder.addCase(getAllPaymentAndReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AccountPaymentAndReceiptList = [];
    });

    builder.addCase(getAllDistributorAndRetailers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllDistributorAndRetailers.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.AccountList = action.payload || [];
      }
    );
    builder.addCase(getAllDistributorAndRetailers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AccountList = [];
    });
  },
});

export const {
  clearAccountDetails,
  setAccountGuID,
  clearAccountGuID,
  setAccountID,
  clearAccountID,
  clearAccountList,
} = accountSlice.actions;
export default accountSlice.reducer;
